import styled from 'styled-components'

export const StyledPaymentsContainer = styled.div`
  margin-top: 24px;
`
